/**
 * Session configuration constants.
 *
 * This file contains shared configuration for session-related features.
 * Centralizing these values ensures consistency across all components.
 */

/**
 * Default estimation options for planning poker voting.
 * Uses a modified Fibonacci sequence commonly used in agile estimation.
 */
export const DEFAULT_ESTIMATION_OPTIONS: readonly (string | number)[] = [1, 2, 3, 5, 8, 13, 21, '?'] as const;

/**
 * Type for a single estimation option value.
 */
export type EstimationOption = (typeof DEFAULT_ESTIMATION_OPTIONS)[number];

/**
 * Type for the array of estimation options.
 */
export type EstimationOptions = readonly (string | number)[];
